export default "__VITE_ASSET__n9D8sixoynFJNDKs__WYCw__";